import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { ConciergeStatus } from "@/lib/admin/concierge-api";

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  target: ConciergeStatus;
  onConfirm: () => void;
};

const COPY: Record<ConciergeStatus, { title: string; body: string; cta: string; danger?: boolean }> = {
  published: {
    title: "Publish this Concierge site?",
    body: "The target user will see this site at /app/concierge as soon as you publish. Make sure the advisor, agent, and resources are ready.",
    cta: "Publish",
  },
  draft: {
    title: "Move back to draft?",
    body: "The site will no longer be visible to the target user until you publish again.",
    cta: "Unpublish",
  },
  archived: {
    title: "Archive this site?",
    body: "The site will be hidden from the target user and removed from active lists.",
    cta: "Archive",
    danger: true,
  },
};

export function PublishConfirmDialog({ open, onOpenChange, target, onConfirm }: Props) {
  const c = COPY[target];
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{c.title}</AlertDialogTitle>
          <AlertDialogDescription>{c.body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={c.danger ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : undefined}
          >
            {c.cta}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default PublishConfirmDialog;
